/* tslint:disable */

declare var Object: any;
export interface OtherOrderItemInterface {
  "orderId": string;
  "productType": string;
  "planType": string;
  "quantity": number;
  "unitPrice": number;
  "unitDiscount": number;
  "discountUnit": string;
  "subTotal": number;
  "totalAmount": number;
  "totalDiscount": number;
  "unitTax": number;
  "totalTax": number;
  "totalVat"?: number;
  "netOfVat"?: number;
  "accountingDocument"?: string;
  "SOANumber"?: string;
  "SOADate"?: Date;
  "id"?: number;
  commissions?: any[];
  order?: any;
}

export class OtherOrderItem implements OtherOrderItemInterface {
  "orderId": string;
  "productType": string;
  "planType": string;
  "quantity": number;
  "unitPrice": number;
  "unitDiscount": number;
  "discountUnit": string;
  "subTotal": number;
  "totalAmount": number;
  "totalDiscount": number;
  "unitTax": number;
  "totalTax": number;
  "totalVat": number;
  "netOfVat": number;
  "accountingDocument": string;
  "SOANumber": string;
  "SOADate": Date;
  "id": number;
  commissions: any[];
  order: any;
  constructor(data?: OtherOrderItemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `OtherOrderItem`.
   */
  public static getModelName() {
    return "OtherOrderItem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of OtherOrderItem for dynamic purposes.
  **/
  public static factory(data: OtherOrderItemInterface): OtherOrderItem{
    return new OtherOrderItem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'OtherOrderItem',
      plural: 'OtherOrderItems',
      path: 'OtherOrderItems',
      idName: 'id',
      properties: {
        "orderId": {
          name: 'orderId',
          type: 'string'
        },
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "planType": {
          name: 'planType',
          type: 'string'
        },
        "quantity": {
          name: 'quantity',
          type: 'number',
          default: 0
        },
        "unitPrice": {
          name: 'unitPrice',
          type: 'number',
          default: 0
        },
        "unitDiscount": {
          name: 'unitDiscount',
          type: 'number',
          default: 0
        },
        "discountUnit": {
          name: 'discountUnit',
          type: 'string',
          default: 'P'
        },
        "subTotal": {
          name: 'subTotal',
          type: 'number',
          default: 0
        },
        "totalAmount": {
          name: 'totalAmount',
          type: 'number',
          default: 0
        },
        "totalDiscount": {
          name: 'totalDiscount',
          type: 'number',
          default: 0
        },
        "unitTax": {
          name: 'unitTax',
          type: 'number',
          default: 0
        },
        "totalTax": {
          name: 'totalTax',
          type: 'number',
          default: 0
        },
        "totalVat": {
          name: 'totalVat',
          type: 'number',
          default: 0
        },
        "netOfVat": {
          name: 'netOfVat',
          type: 'number',
          default: 0
        },
        "accountingDocument": {
          name: 'accountingDocument',
          type: 'string'
        },
        "SOANumber": {
          name: 'SOANumber',
          type: 'string'
        },
        "SOADate": {
          name: 'SOADate',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        commissions: {
          name: 'commissions',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'orderItemId'
        },
        order: {
          name: 'order',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'orderId',
          keyTo: 'id'
        },
      }
    }
  }
}
